module.exports = __webpack_public_path__ + "img/zh.7d62636a.svg";